export { default } from '@/pages/sklep/panel/ulubione'
